// extracted by mini-css-extract-plugin
module.exports = {"header":"style_header__ojEao","header__wrapper":"style_header__wrapper__alIEn","header-logo":"style_header-logo__MUGIX"};